import { notification } from "antd";
import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "redux/constants/Auth";

import history from "../history";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 180000,
});

// Config
export const ENTRY_ROUTE = "/auth/login";
export const TOKEN_PAYLOAD_KEY = "token";
const PUBLIC_REQUEST_KEY = "public-request";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    // use this token till login API is implemented 29/09/2021
    // let jwtToken =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MTYzZGI1MTlkNzRmNzAwMTE2Mjc4MjMiLCJlbWFpbCI6InRlc3RpbmdAamV0YXRlY2guY29tIiwicm9sZSI6IlVTRVIiLCJzdWJzY3JpYmVyIjp7Il9pZCI6IjYxNGNjMTcxNDVlZmRiMDAxMmMwNzhjNiIsIm5hbWUiOiJKZXRhdGVjaCIsImNvZGUiOiJqZXRhdGVjaCJ9LCJpYXQiOjE2MzU4NTEyMzEsImV4cCI6MTY2NzQwODgzMX0.Sfd1NLuuamzro8_nnvayLEewvc6VRVtt640xB7NFBDE"
    let jwtToken = localStorage.getItem(AUTH_TOKEN);
    let jwtPublicToken = sessionStorage.getItem(AUTH_TOKEN)

    if (localStorage.getItem("isPublic") === "true") {
      jwtToken = localStorage.getItem(AUTH_TOKEN);
    }

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }

    if (jwtPublicToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtPublicToken;
    }

    if (
      !jwtToken &&
      !config.headers[PUBLIC_REQUEST_KEY] &&
      !isLoginRelatedApi(config)
    ) {
      history.push(ENTRY_ROUTE);
      // window.location.reload();
    }

    return config;
  },
  (error) => {
  
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
   

    let notificationParam = {
      message: "",
    };

    if (error?.response?.status === 401) {
      notificationParam.message = "Authentication Fail";
      notificationParam.description = "Please login again";
      notification.error(notificationParam);
      localStorage.removeItem(AUTH_TOKEN);
      history.push(ENTRY_ROUTE);
      window.location.reload();
      return;
    }
    if (error?.response?.status === 508) {
      notificationParam.message = "Time Out";
    }
    return Promise.reject(error);
  }
);

const isLoginRelatedApi = (config) => {
  const { url } = config;
  return url.includes("/auth");
};

export default service;
